if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          bubble: this.querySelector('.hidden-thumb-count-bubble'),
        };
        this.mql = window.matchMedia('(min-width: 750x)');
        this.variantChangeHandler = null;
        this.colorFallbackHandler = null;
        this.addEventListeners();

        // Set up custom dot update handler for variant-based dots
        this.setupVariantDotHandler();

        if (!this.elements.thumbnails) return;

        // Add thumbnail image handling
        this.setupThumbnailImages();

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          const button = mediaToSwitch.querySelector('button');
          button.addEventListener('click', () => {
            const targetId = mediaToSwitch.dataset.target;

            this.setActiveMedia(targetId, false);
            const opener = this.elements.viewer.querySelector(
              `[data-media-id="${targetId}"] .product__media-toggle`,
            );

            if (opener) {
              const { indexPosition } = opener.dataset;
              const modalOpener = opener.closest('modal-opener');
              const modalSelector = modalOpener?.getAttribute('data-modal');

              opener.click();

              // Find and set scroll position instantly (no animation, user won't see scroll)
              if (indexPosition && modalSelector) {
                const modal = document.querySelector(modalSelector);
                if (modal) {
                  // Use double RAF to ensure modal is fully rendered and visible
                  requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                      // Check if modal is actually open
                      if (!modal.hasAttribute('open')) return;

                      // Prefer the currently visible
                      //  variant media so we don't match hidden variants
                      const modalImage = modal.querySelector(
                        `.product-media-modal__media:not(.hidden) [data-index="modal-media-${indexPosition}"]`,
                      ) || modal.querySelector(`[data-index="modal-media-${indexPosition}"]`);
                      if (!modalImage) return;

                      // Check if image is visible (not in hidden variant container)
                      const imageRect = modalImage.getBoundingClientRect();
                      if (imageRect.width === 0 || imageRect.height === 0) return;

                      const modalContent = modal.querySelector('.product-media-modal__content');
                      if (!modalContent) return;

                      // Use getBoundingClientRect for accurate positioning
                      const contentRect = modalContent.getBoundingClientRect();
                      const contentScrollTop = modalContent.scrollTop;
                      const imageTopRelative = imageRect.top - contentRect.top + contentScrollTop;
                      const contentHeight = modalContent.clientHeight;
                      const imageHeight = imageRect.height;
                      const centerOffset = contentHeight / 2;
                      const imageCenter = imageHeight / 2;

                      modalContent.scrollTop = imageTopRelative - centerOffset + imageCenter;
                    });
                  });
                }
              }
            }
          });
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      setupVariantDotHandler() {
        const sliderElement = this.elements.viewer.querySelector('[id^="Slider-"]');
        if (!sliderElement) return;

        // Check if this is a variant-based gallery
        const hasVariantGroups = this.elements.viewer.querySelector('[data-variant-dots-group]');

        if (hasVariantGroups) {
          // Add our custom scroll listener for variant dots
          sliderElement.addEventListener('scroll', debounce(this.updateVariantDots.bind(this), 50));

          // Override the global SliderComponent's updateDots to prevent conflicts
          const sliderComponent = this.elements.viewer;
          if (sliderComponent && sliderComponent.updateDots) {
            sliderComponent.updateDots = () => {}; // No-op for variant galleries
          }
        }
      }

      updateVariantDots() {
        const sliderElement = this.elements.viewer.querySelector('[id^="Slider-"]');
        if (!sliderElement) return;

        // Find the first visible variant slide to determine which variant is active
        const firstVisibleSlide = this.elements.viewer.querySelector(
          '[data-variant-slider-group]:not(.hidden)'
        );

        if (!firstVisibleSlide) return;

        const variantId = firstVisibleSlide.dataset.variantSliderGroup;

        const variantDotsGroup = this.elements.viewer.querySelector(
          `[data-variant-dots-group="${variantId}"]`
        );

        if (!variantDotsGroup) return;

        const dots = variantDotsGroup.querySelectorAll('.slider-dot');
        if (!dots.length) return;

        // Get visible slides for this variant
        const slides = Array.from(
          this.elements.viewer.querySelectorAll(`[data-variant-slider-group="${variantId}"]`)
        ).filter(slide => slide.clientWidth > 0);

        if (!slides.length) return;

        const slideWidth = slides[0].clientWidth;
        const scrollLeft = sliderElement.scrollLeft;
        const activeIndex = Math.round(scrollLeft / slideWidth);

        dots.forEach((dot, index) => {
          if (index === activeIndex) {
            dot.classList.add('slider-dot--active');
          } else {
            dot.classList.remove('slider-dot--active');
          }
        });
      }

      // Add new method to handle thumbnail images
      setupThumbnailImages() {
        const thumbnailImages = this.elements.thumbnails.querySelectorAll('.thumbnail img');
        thumbnailImages.forEach(img => {
          if (img.complete) {
            this.handleThumbnailImageLoad(img);
          } else {
            img.addEventListener('load', () => this.handleThumbnailImageLoad(img));
          }
        });
        this.updateHiddenThumbnailCountBubble();
        this.updateThumbnailWrapperVisibility();
      }

      updateThumbnailWrapperVisibility() {
        if (!this.elements.thumbnails) return;
        const wrapper = this.querySelector('.thumbnail-slider-wrapper');
        if (!wrapper) return;

        const items = this.elements.thumbnails.querySelectorAll('.thumbnail-list__item');
        const visibleCount = Array.from(items).filter((item) => !item.classList.contains('hidden')).length;

        if (visibleCount > 1) {
          wrapper.classList.remove('hidden');
          wrapper.removeAttribute('hidden');
        } else {
          wrapper.classList.add('hidden');
          wrapper.setAttribute('hidden', '');
        }
      }

      updateHiddenThumbnailCountBubble() {
        const hiddenCount = this.gethiddenThumbnailCount();
        if (!this.elements.bubble) return;
        if (hiddenCount > 0) {
          this.elements.bubble.textContent = `+${hiddenCount}`;
          _.removeClass(this.elements.bubble, 'hidden');
        } else {
          // bubble.classList.add('hidden');
          _.addClass(this.elements.bubble, 'hidden');
        }
      }

      gethiddenThumbnailCount() {
        const thumbnailItems = this.elements.thumbnails.querySelectorAll('.thumbnail-list__item');
        return Array.from(thumbnailItems).filter((item) => {
          if (item.classList.contains('hidden')) return false;
          const img = item.querySelector('img');
          if (!img) return false;
          const rect = img.getBoundingClientRect();
          const parentRect = this.elements.thumbnails.parentElement.getBoundingClientRect();
          return rect.right > parentRect.right; // Only consider thumbnails hidden to the right
        }).length;
      }

      // Listen for variant changes
      addEventListeners() {
        const gallery = this.elements.viewer;
        const status = this.elements.liveRegion;
        const isGmProduct = status?.dataset.gmProduct === 'true';
        if (!gallery) return;

        const slides = gallery.querySelectorAll('.slider__slide');
        // Check if this gallery uses variant-specific media
        const hasVariantGroups = gallery.querySelector('[data-variant-slider-group]');

        this.variantChangeHandler = (event) => {
          const { variant } = event.detail;
          const variantOption = variant ? variant.title.replace(/\s+/g, '-').toLowerCase() : null;
          if (!variantOption) return;

          // Only show/hide variant media if this gallery uses variant groups
          if (hasVariantGroups) {
            // Show only slides for selected variant (mobile slider)
            this.showVariantMedia(variant.id);

            // Show only thumbnails for selected variant (desktop)
            this.showVariantThumbnails(variant.id);
          }

          // find slide that matches variant option
          // eslint-disable-next-line max-len
          const slideToShow = Array.from(slides).find((s) => s.dataset.variantOption === variantOption);
          // Update image to selected variant
          if (slideToShow) {
            // On variant change, avoid scrolling the page to the media gallery.
            // Users can change variants while scrolled down in the form.
            this.setActiveMedia(slideToShow.dataset.mediaId, true, false);
          }
        };

        document.addEventListener('variant:change', this.variantChangeHandler);

        // Listen for color option changes when variant:change doesn't fire (unavailable size)
        if (hasVariantGroups) {
          this.colorFallbackHandler = (event) => {
            const { variantId } = event.detail;
            if (variantId) {
              this.showVariantMedia(variantId);
              this.showVariantThumbnails(variantId);
            }
          };

          document.addEventListener('variant:color-fallback', this.colorFallbackHandler);
        }
      }

      disconnectedCallback() {
        if (this.variantChangeHandler) {
          document.removeEventListener('variant:change', this.variantChangeHandler);
        }
        if (this.colorFallbackHandler) {
          document.removeEventListener('variant:color-fallback', this.colorFallbackHandler);
        }
      }

      showVariantMedia(variantId) {
        if (!variantId) return;

        const variantIdStr = variantId.toString();

        const dotGroups = this.elements.viewer.querySelectorAll('[data-variant-dots-group]');
        dotGroups.forEach((group) => {
          if (group.dataset.variantDotsGroup === variantIdStr) {
            group.style.display = 'contents';
          } else {
            group.style.display = 'none';
          }
        });

        // Reset slider scroll position to first slide BEFORE showing new variant (no animation)
        const sliderElement = this.elements.viewer.querySelector('[id^="Slider-"]');
        if (sliderElement) {
          sliderElement.scrollTo({
            left: 0,
            behavior: 'instant'
          });
        }

        // Show/hide individual variant slides
        const variantSlides = this.elements.viewer.querySelectorAll('[data-variant-slider-group]');
        let firstVisibleSlide = null;
        variantSlides.forEach((slide) => {
          if (slide.dataset.variantSliderGroup === variantIdStr) {
            slide.classList.remove('hidden');
            if (!firstVisibleSlide) firstVisibleSlide = slide;
          } else {
            slide.classList.add('hidden');
          }
        });

        // Make first slide of selected variant active
        const allSlides = this.elements.viewer.querySelectorAll('.slider__slide');
        allSlides.forEach(slide => slide.classList.remove('is-active'));

        if (firstVisibleSlide) {
          firstVisibleSlide.classList.add('is-active');
        }

        // Reset slider if it exists
        if (this.elements.viewer.slider && this.elements.viewer.slider.resetPages) {
          this.elements.viewer.slider.resetPages();
        }

        // Update dots for the new variant immediately
        this.updateVariantDots();
      }

      showVariantThumbnails(variantId) {
        if (!this.elements.thumbnails || !variantId) return;

        const variantIdStr = variantId.toString();
        const thumbnails = this.elements.thumbnails.querySelectorAll('.thumbnail-list__item[data-variant-id]');

        thumbnails.forEach((thumbnail) => {
          if (thumbnail.dataset.variantId === variantIdStr) {
            thumbnail.classList.remove('hidden');
          } else {
            thumbnail.classList.add('hidden');
          }
        });

        // Update the hidden thumbnail count bubble
        this.updateHiddenThumbnailCountBubble();
        this.updateThumbnailWrapperVisibility();
      }

      getCurrentVariantId() {
        try {
          const selectedVariantEl = document.querySelector('variant-selects [data-selected-variant]');
          if (!selectedVariantEl) return null;
          const json = selectedVariantEl.textContent || selectedVariantEl.innerHTML || '';
          const variant = JSON.parse(json);
          return variant?.id?.toString() || null;
        } catch (e) {
          console.warn('Could not find selected variant', e);
          return null;
        }
      }

      // Add new method to handle image load
      handleThumbnailImageLoad(img) {
        const isWide = img.naturalWidth > img.naturalHeight;
        img.style.objectFit = isWide ? 'cover' : 'contain';
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`,
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend, shouldScroll = true) {
        // For variant-based galleries, prefer visible (non-hidden) slides
        const visibleMatch = this.elements.viewer.querySelector(
          `[data-variant-slider-group]:not(.hidden)[data-media-id="${mediaId}"]`
        );

        let activeMedia = visibleMatch
          || this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`)
          || this.elements.viewer.querySelector('[data-media-id]');

        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          if (activeMedia.parentElement.firstChild !== activeMedia) {
            activeMedia.parentElement.prepend(activeMedia);
          }

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            if (activeThumbnail?.parentElement?.firstChild !== activeThumbnail) {
              activeThumbnail?.parentElement?.prepend(activeThumbnail);
            }
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!shouldScroll) return;
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        if (activeThumbnail) {
          this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
